import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import type { FC } from "react";
import { NEUTRAL } from "../../../../theme/tokens";
import type { ThresholdStatus } from "../types";
import type { TableDiffItem } from "./type";

interface ItemProps {
	item: TableDiffItem;
	status: ThresholdStatus;
	color: string;
	wantedWrapper?: (value: number) => React.ReactNode;
	actualWrapper?: (value: number) => React.ReactNode;
}

export const Item: FC<ItemProps> = ({ item, color, wantedWrapper, actualWrapper }) => {
	return (
		<Box
			key={item.title}
			sx={{
				display: "flex",
				justifyContent: "space-between",
				alignItems: "center",
				marginBottom: 1.5,
			}}
		>
			<Typography
				onDoubleClick={item.onDoubleClick}
				sx={{
					fontSize: 14,
					color: NEUTRAL[600],
					fontWeight: 400,
					cursor: item.onDoubleClick ? "pointer" : "default",
					"&:hover": item.onDoubleClick
						? {
								textDecoration: "underline",
							}
						: {},
				}}
			>
				{item.title}
			</Typography>
			<Box
				sx={{
					display: "flex",
					flexDirection: "row",
					gap: 0.5,
				}}
			>
				<Typography
					sx={{
						fontSize: 14,
						fontWeight: 700,
						color,
					}}
				>
					{actualWrapper ? actualWrapper(item.actual) : item.actual}
				</Typography>
				{wantedWrapper?.(item.wanted)}
			</Box>
		</Box>
	);
};
